import tw from 'twin.macro';

export const Hint = tw.p`mb-4 text-xs text-gray-500`;
